import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import { getApplyCaptcha, verifyApplyCaptcha, getVerificationCode, register, presentation } from "@/services";

export const fetchApplyCaptcha = createAsyncThunk("fetchApplyCaptcha", async (payload) => {
	const res = await getApplyCaptcha(payload);
	return res;
});

export const fetchVerifyApplyCaptcha = createAsyncThunk("fetchVerifyApplyCaptcha", async (payload) => {
	const res = await verifyApplyCaptcha(payload);
	return res;
});

export const fetchVerificationCode = createAsyncThunk("fetchVerificationCode", async (payload) => {
	const res = await getVerificationCode(payload);
	return res;
});

export const fetchRegister = createAsyncThunk("fetchRegister", async (payload) => {
	const res = await register(payload);
	return res;
});

export const fetchPresentation = createAsyncThunk("fetchPresentation", async (payload) => {
	const res = await presentation(payload);
	return res;
});

const RegisterSlice = createSlice({
	name: "register",
	initialState: {},
	reducers: {},
	extraReducers: (builder) => {
		builder
			.addCase(fetchApplyCaptcha.rejected, (_, payload) => {
				throw new Error(payload.error.message);
			})
			.addCase(fetchVerifyApplyCaptcha.rejected, (_, payload) => {
				throw new Error(payload.error.message);
			})
			.addCase(fetchVerificationCode.rejected, (_, payload) => {
				throw new Error(payload.error.message);
			})
			.addCase(fetchRegister.rejected, (_, payload) => {
				throw new Error(payload.error.message);
			})
			.addCase(fetchPresentation.rejected, (_, payload) => {
				throw new Error(payload.error.message);
			});
	},
});

// export const { changeUserInfo } = LoginSlice.actions;

export default RegisterSlice.reducer;
